import { render, staticRenderFns } from "./CreateBundling.vue?vue&type=template&id=9b418cec&"
import script from "./CreateBundling.vue?vue&type=script&lang=js&"
export * from "./CreateBundling.vue?vue&type=script&lang=js&"
import style0 from "./CreateBundling.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports